import { Button, NoResults, Pagination } from '..';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import {
	Grid,
	Table as MuiTable,
	Paper,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
} from '@material-ui/core';
import { type IMetadata } from 'src/models';
import { LabelField } from 'src/components';
import { reorder } from 'src/helpers';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import _ from 'lodash';
import clsx from 'clsx';
import useStyles from './Table-styles';

export interface TableConfig {
	label: string;
	key: string;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	render: (value: string | number, row: any) => any;
	align?: 'center' | 'left' | 'right';
}

export interface TableAction {
	label: string;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	onClick: (row: any) => void;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	disabled?: boolean | ((row: any) => boolean);
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	render?: (row: any) => any;
}
interface Props {
	columns: TableConfig[];
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	data: any[];
	actions?: TableAction[];
	hidePagination?: boolean;
	page?: number;
	metadata?: IMetadata;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	handlePagination?: (event: any, newPage: number) => void;
	enableDrag?: boolean;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	handleDrag?: (reorderedData: any[]) => void;
	actionsLabel?: string;
}

function Table({
	actions,
	actionsLabel,
	columns,
	data,
	enableDrag = false,
	handleDrag = (reorderedData: any[]) => {},
	handlePagination,
	hidePagination,
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	metadata,
	page,
}: Props) {
	const classes = useStyles();

	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	function onDragEnd({ destination, draggableId }: any) {
		if (destination) {
			const reorderedData = reorder(data, draggableId, destination.index);
			handleDrag(reorderedData);
		}
	}

	return (
		<Grid
			className={clsx({ [classes.container]: hidePagination })}
			container
			spacing={2}
		>
			<MuiTable
				className={classes.desktop}
				style={{ borderCollapse: 'separate', borderSpacing: '0 1em' }}
			>
				<TableHead>
					<TableRow>
						{columns.map((column: TableConfig, index: number) => (
							<TableCell align={column.align} key={index}>
								{' '}
								{column.label}{' '}
							</TableCell>
						))}

						{actions !== null && (
							<TableCell align={'right'}>
								{' '}
								{actionsLabel || 'Opciones'}{' '}
							</TableCell>
						)}
					</TableRow>
				</TableHead>

				{data?.length > 0 && (
					<DragDropContext onDragEnd={onDragEnd}>
						<Droppable droppableId={'droppable'}>
							{
								// NOTE:
								// ./src/modules/Private/Courses/Course.tsx[22:8]
								(provided: any) => (
									<TableBody
										{...provided.droppableProps}
										className={classes.tableBody}
										ref={provided.innerRef}
									>
										{
											// NOTE:
											// ./src/modules/Private/Courses/Course.tsx[22:8]
											data.map(
												(row: any, index: number) => (
													<Draggable
														draggableId={(
															row.id || index
														).toString()}
														index={index}
														isDragDisabled={
															!enableDrag
														}
														key={row.id || index}
													>
														{
															// NOTE:
															// ./src/modules/Private/Courses/Course.tsx[22:8]
															(
																provided: any,
																snapshot: any,
															) => (
																<TableRow
																	className={
																		classes.row
																	}
																	key={index}
																	ref={
																		provided.innerRef
																	}
																	{...provided.draggableProps}
																	{...provided.dragHandleProps}
																>
																	{columns.map(
																		(
																			{
																				align,
																				key,
																				render,
																			}: TableConfig,
																			index: number,
																		) => {
																			const value =
																				_.get(
																					row,
																					key,
																				);

																			return (
																				<TableCell
																					align={
																						align
																					}
																					key={
																						key
																					}
																					style={
																						Boolean(
																							enableDrag,
																						) &&
																						index ===
																							0
																							? {
																									alignItems:
																										'center',
																									display:
																										'flex',
																									flexDirection:
																										'row',
																							  }
																							: {}
																					}
																				>
																					{Boolean(
																						enableDrag,
																					) &&
																						index ===
																							0 && (
																							<TableCell>
																								{' '}
																								<MoreVertIcon />{' '}
																							</TableCell>
																						)}

																					{snapshot.isDragging &&
																					index !==
																						0
																						? ''
																						: render(
																								value,
																								row,
																						  )}
																				</TableCell>
																			);
																		},
																	)}

																	<TableCell
																		align={
																			'right'
																		}
																	>
																		{actions?.map(
																			(
																				action: TableAction,
																				index: number,
																			) => {
																				if (
																					!snapshot.isDragging
																				) {
																					if (typeof action.render !== 'undefined') {
																						// @ts-ignore
																						return action.render(
																							row,
																						);
																					}

																					return (
																						<Button
																							backgroundColor={
																								'white'
																							}
																							disabled={
																								_.isFunction(
																									action.disabled,
																								)
																									? action.disabled(
																											row,
																									  )
																									: action.disabled
																							}
																							key={
																								index
																							}
																							onClick={() => {
																								action.onClick(
																									row,
																								);
																							}}
																							small
																							style={{
																								margin: 4,
																							}}
																						>
																							{
																								action.label
																							}
																						</Button>
																					);
																				}
																			},
																		)}
																	</TableCell>
																</TableRow>
															)
														}
													</Draggable>
												),
											)
										}
									</TableBody>
								)
							}
						</Droppable>
					</DragDropContext>
				)}
			</MuiTable>

			<div className={classes.mobile}>
				{data?.length > 0 && (
					<DragDropContext onDragEnd={onDragEnd}>
						<Droppable droppableId={'droppable'}>
							{
								// NOTE:
								// ./src/modules/Private/Courses/Course.tsx[22:8]
								(provided: any) => (
									<div
										{...provided.droppableProps}
										ref={provided.innerRef}
										style={{ width: '100%' }}
									>
										{
											// NOTE:
											// ./src/modules/Private/Courses/Course.tsx[22:8]
											data.map(
												(row: any, index: number) => (
													<Draggable
														draggableId={(
															row.id || index
														).toString()}
														index={index}
														isDragDisabled={
															!enableDrag
														}
														key={row.id || index}
													>
														{
															// NOTE:
															// ./src/modules/Private/Courses/Course.tsx[22:8]
															(
																provided: any,
																snapshot: any,
															) => (
																<Paper
																	className={clsx(
																		classes.row,
																		classes.card,
																	)}
																	key={index}
																	ref={
																		provided.innerRef
																	}
																	{...provided.draggableProps}
																	{...provided.dragHandleProps}
																>
																	{columns.map(
																		(
																			{
																				key,
																				render,
																			}: TableConfig,
																			index: number,
																		) => {
																			const value =
																				_.get(
																					row,
																					key,
																				);

																			return (
																				<div
																					key={
																						key
																					}
																					style={
																						Boolean(
																							enableDrag,
																						) &&
																						index ===
																							0
																							? {
																									alignItems:
																										'center',
																									display:
																										'flex',
																									flexDirection:
																										'row',
																									marginBottom: 8,
																									width: '100%',
																							  }
																							: {
																									marginBottom: 8,
																									width: '100%',
																							  }
																					}
																				>
																					<LabelField
																						label={
																							index ===
																							0
																								? 'Nombre'
																								: columns[
																										index
																								  ]
																										.label
																						}
																						spaceBetween
																						value={
																							snapshot.isDragging &&
																							index !==
																								0
																								? ''
																								: render(
																										value,
																										row,
																								  )
																						}
																					/>
																				</div>
																			);
																		},
																	)}

																	<div
																		className={
																			classes.cardActions
																		}
																	>
																		{actions?.map(
																			(
																				action: TableAction,
																				index: number,
																			) => {
																				if (
																					!snapshot.isDragging
																				) {
																					if (typeof action.render !== 'undefined') {
																						// @ts-ignore
																						return action.render(
																							row,
																						);
																					}

																					return (
																						<Button
																							backgroundColor={
																								'white'
																							}
																							key={
																								index
																							}
																							onClick={() => {
																								action.onClick(
																									row,
																								);
																							}}
																							small
																							style={{
																								margin: 4,
																							}}
																						>
																							{
																								action.label
																							}
																						</Button>
																					);
																				}
																			},
																		)}
																	</div>
																</Paper>
															)
														}
													</Draggable>
												),
											)
										}
									</div>
								)
							}
						</Droppable>
					</DragDropContext>
				)}
			</div>

			{!hidePagination && data?.length > 0 && (
				<Pagination
					handlePagination={handlePagination}
					metadata={metadata}
					page={page}
				/>
			)}

			{data?.length === 0 && <NoResults />}
		</Grid>
	);
}

export default Table;
